import {
  CompetitionStatus,
  getCompetitionStatus,
} from '@/constants/competition-status'
import { cn } from '@/lib/utils'
import { Competition } from '@/redux/competition'

export interface CompetitionStatusProps {
  competition: Competition
}

export default function CompetitionStatusView({ competition }: CompetitionStatusProps) {
  const status = getCompetitionStatus(competition)
  return (
    <div
      className={cn(
        status === CompetitionStatus.OnProgress && 'bg-linear-to-r from-gradient-blue to-gradient-purple text-white',
        status === CompetitionStatus.Ended && 'text-disabled-foreground',
        'text-xs px-2 py-1 rounded-sm bg-white/12 inline-block',
      )}
    >
      {status.toString()}
    </div>
  )
}
